import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface SectorSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export const sectorOptions = [
  "Agency",
  "Charity",
  "Consumer Accessories",
  "Cosmetics, Make-Up & Beauty",
  "E-Commerce",
  "Fashion & Apparel",
  "Film & TV",
  "Financial Services",
  "Food & Beverages",
  "Health & Wellbeing",
  "Record Label",
  "Social Media",
  "Travel",
  "Video Games & Apps",
  "Other",
] as const;

export default function SectorSelect(props: SectorSelectProps) {
  const { isErrored, onChange, readOnly, required, value } = props;

  return (
    <StringFormCombobox
      id="sector-select"
      options={sectorOptions}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
    />
  );
}
